import { render, staticRenderFns } from "./serviceFee.vue?vue&type=template&id=670af05a&scoped=true&"
import script from "./serviceFee.vue?vue&type=script&lang=js&"
export * from "./serviceFee.vue?vue&type=script&lang=js&"
import style0 from "./serviceFee.vue?vue&type=style&index=0&id=670af05a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670af05a",
  null
  
)

export default component.exports